/* File: delivery.js
 * -----------------
 * File calculates the distances from Google APIs and accordingly gives the
 * user option for selecting delivery option and also calcualtes the prices
 * and various times for the delivery.
 */

import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import alertIcon from './../../../images/alert.png';
import template from './guestDelivery.html';
import shippingOfferInfoIcon from './../../../images/shipping-info.png';
import shippingOfferAvailableIcon from './../../../images/shipping-tick.png';
import info from './../../../images/question.png';


@Component({
  controllerAs: 'guestdelivery',
  template
})

export default class guestDelivery {
  static $inject = [
    '$scope',
    '$rootScope',
    '$ngRedux',
    '$state',
    '$uibModal',
    'toaster',
    'spinnerService',
    'authService',
    'orderService',
    '$q',
    '$window',
    '$cookies',
    '$stateParams',
    'APP',
    '$sce'
  ];

  constructor($scope, $rootScope, $ngRedux, $state, $uibModal, toaster, $spinner, $auth, $order, $q, $window, $cookies, $stateParams, APP, $sce) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.$order = $order;
    this.$auth = $auth;
    this.$spinner = $spinner;
    this.$q = $q;
    this.$sce=$sce;
    this.$stateParams = $stateParams;
    this.$cookies = $cookies;
    this.$window = $window;
    this.APP = APP;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.alertIcon = alertIcon;
    this.info = info;
    this.shippingOfferInfoIcon = shippingOfferInfoIcon;
    this.shippingOfferAvailableIcon = shippingOfferAvailableIcon;
    this.shippingOffer = {};
    this.shippingOffer.isOfferEligible = false;
    this.shippingOffer.thresholdAmount = 1500;
    this.billingStates = [];
    this.shippingStates = [];
    this.isMiscelleneousCategory = 4;
    this.giftCardMasterCodeStartsWith = '9';
    this.dscMasterCode = '88888888'; // Named constant
    this.mode = '';
    this.noItemsInCart = false;
    this.isDiscountError = false;
    this.isCartError = false;
    this.isCartExceptionError = false;
    this.isGiftOrder = false;    
    this.shippingAddressValidation = false;
    this.isAddressValidated = false;
    this.isEmailNull = false;
    this.iszipCodeNull = false;
    this.isPhoneNumberNull = false;
    this.noTimeForOrderReadyBy = false;
    this.showDefaultFedexErrorMessage=true;
    this.fedexErrorMessage = "";
    this.fedexErrorMessageHtml = "";
    this.ordernotesPattern = "^[ a-zA-Z0-9~%!@#$^&*()_+={}|\\\\,.?:\"'\/:;<`>-]*$";
    
    this.promoLengthToBeShown=25;
    this.userDetail = this.$rootScope.guestUserDetails ? this.$rootScope.guestUserDetails : (
      sessionStorage.getItem('guestUserDetails') ? JSON.parse(sessionStorage.getItem('guestUserDetails')) :
        {
          email: null,
          firstName: null,
          lastName: null,
          addressLine1: null,
          addressLine2: null,
          city: null,
          state: null,
          zipCode: null,
          country: null,
          phoneNumber: null,
          recipientFirstName: null,
          recipientLastName: null,
          shipping: {
            addressLine1: null,
            addressLine2: null,
            city: null,
            state: null,
            zipCode: null,
            country: null,
            isCopyAsShipping: false
          }
        });
    this.curbSideDetails = this.$rootScope.curbSideDetails ? this.$rootScope.curbSideDetails : (
      (sessionStorage.getItem('curbSideDetails') && sessionStorage.getItem('curbSideDetails') !== "undefined") ? JSON.parse(sessionStorage.getItem('curbSideDetails')) : {
        carName: null,
        phNo: null
      });
    this.userForm;
    this.curbsideForm;
    this.estimatedDeliveryDateTime = null;
    this.couponAmount = 0;
    this.init();
    this.taxableDiscountAmount = 0;
    this.calledTaxCount = 0;
    this.nextDayDelivery = 'Next Day Delivery';
    this.inStoreDelivery = 'In Store Pickup';
    this.instorePickupOnly = 'InStore';
    this.dropShipOnly = 'DropShip';
    this.isCurbside = false;
    $window.scrollTo(0, 0);
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      store: state.auth.store,
      cartDetail: state.order.cartDetail,
      cardInfo: state.order.paymentInfo,
      zoneDeliveryCharges: state.order.zoneDeliveryCharges,
      coupon: state.order.coupon,
      taxes: state.order.taxes,
      discountCoupon: state.order.discountCoupon,
      birdBucksList: state.order.birdBucksList,
      storeDiscountMap: state.order.storeDiscountMap,
      orderPoints: state.order.orderPoints,
      erplyShop: state.order.cartDetail.erplyShopCartResponse,
      erplyBirdBucksList: state.order.erplyBirdBucksList,
      guestCartList: state.auth.guestCartList,
      storeDetail: state.auth.storeDetail,
      billingCountries: state.auth.countries
    };
  }

  async init() {
    let { $spinner, $order, $q } = this;
    this.cError = false;
    this.couponAmount = 0;
    this.taxableDiscountAmount = 0;
    this.discountCouponAmount = 0;
    this.discountCouponCode = sessionStorage.getItem('discountCoupon') ? sessionStorage.getItem('discountCoupon') : null;
    this.orderNotes = sessionStorage.getItem('orderNotesSession');

    if(!this.orderNotes || this.orderNotes=="undefined") {
      this.orderNotes = "";
    }

    $spinner.show('appSpinner');
    if (this.$auth.isGuestLogin()) {
      await this.$auth.getStore();
      await this.$auth.getCountries();
      await $order.getZoneWiseDeliveryChargesForGuest();
      await this.$auth.getGuestCart();
      
      if (this.store.country && this.store.country.countryCode) {
        this.userDetail.country = this.userDetail.country ? this.userDetail.country : this.store.country.countryCode;
        this.countryChange(this.userDetail.country, false);
        if (this.userDetail.shipping.country) {
          if (this.userDetail.shipping.zipCode) {
            this.isShippingAddressAdded = true;
          }
          this.countryChange(this.userDetail.shipping.country, true);
        }
      }

      await this.getGuestCartDetails(true);
      // await $order.getStoreDiscountMapping();
      $spinner.hide('appSpinner');
      this.holidays = this.storeDetail.storeTimings.filter(e => e.isHoliday);
    }
  }

  async getGuestCartDetails(hideSpinner = false) {
    if (!hideSpinner) {
      this.$spinner.show('appSpinner');
    }
    this.isCallingAPI = true;
    await this.$order.getGuestCartDetail(this.createGuestCartRequest())
      .then(success => {

        if(this.store.hasErply){
          this.setErplyCartResponseValue(success.data);
        }

        if (this.cartDetail) {
          this.processDeliveryType();
          if (this.cartDetail.shopCartResponse) {
            this.discountCouponAmount = this.cartDetail.shopCartResponse.promoDiscount;
          }
          if (this.cartDetail.discountError && this.cartDetail.discountError.length && this.cartDetail.discountError.filter(ele => ele).length) {
            this.isDiscountError = true;
            this.discountCouponCode = '';
            sessionStorage.setItem('discountCoupon', this.discountCouponCode);
            this.createGuestCartRequest();
          } else {
            this.isDiscountError = false;
            if(success.data && success.data.baseResponse){
              if(success.data.baseResponse.successCode=='200'){
                this.isErplyCampaignValid = true;
              } else {
                this.discountCouponCode = '';
                sessionStorage.setItem('discountCoupon', this.discountCouponCode);
                this.isErplyCampaignValid = false;
              }
              this.erplyCampaignStatus =  success.data.baseResponse.message;
            }
          }
          if (this.cartDetail.cartError && this.cartDetail.cartError.length && this.cartDetail.cartError.filter(ele => ele).length) {
            this.isCartError = true;
            if (!this.store.hasErply && this.cartDetail.cartError.find(ele => ele.includes('Exception occured while connecting the Tax Jar API.'))) {
              this.isCartExceptionError = true;
              this.cartDetail.cartError = this.cartDetail.cartError.filter(ele => !ele.includes('Exception occured while connecting the Tax Jar API.'));
              this.toaster.pop('success', 'Error in calculating Tax!');
            } else {
              this.isCartExceptionError = false;
            }
            if (this.store.hasErply && this.cartDetail.cartError.find(ele => ele.includes('FedexError'))) {
              var ctrl1 = this;
              for(var i=0; i<this.cartDetail.cartError.length; i++) {
                if(this.cartDetail.cartError[i].includes("FedexError")) {
                  this.fedexErrorMessageHtml = this.cartDetail.cartError[i].split("|")[1];
                  this.showDefaultFedexErrorMessage = false;
                  this.fedexErrorMessage = this.getFedexErrorMessageFromhtmlErrorMsg(this.fedexErrorMessageHtml);
                  break;
                }else{
                  this.showDefaultFedexErrorMessage = true;
                }
              }
            } else {
              this.showDefaultFedexErrorMessage = true;
            }
            // this.$window.scrollTo(0, 0);
          } else {
            this.isCartExceptionError = false;
            this.isCartError = false;
          }
        }
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        this.isCallingAPI = false;
        this.$spinner.hide('appSpinner');
      });
  }

  getFedexErrorMessageFromhtmlErrorMsg(fedexErrorMessageHtml){
    fedexErrorMessageHtml = fedexErrorMessageHtml.replace("<br/>","");
    return fedexErrorMessageHtml;
  }

  createGuestCartRequest() {
    const cartData = this.guestCartList.filter(data => !data.isDscCard);
    const request = {
      isGuest: true,
      isCheckoutCart: true,
      email : this.userDetail.email,
      deliveryType: this.mode ? this.mode : this.inStoreDelivery,
      shipTo: this.createShipToRequest(),
      shippingCharge: +this.getSelectedShipmentCharge() ? (this.getSelectedShipmentCharge()).toFixed(2) || 0 : 0,
      shippingDiscount: +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0,
      manualPromotionIDs: this.discountCouponCode ? [this.discountCouponCode] : null,
      guestCartItems: cartData
    };
    sessionStorage.setItem('GuestCartRequest', JSON.stringify(request));
    console.log("sessionStorage.getItem('GuestCartRequest')",sessionStorage.getItem('GuestCartRequest'));
    return request;
  }

  onCurbsideChanges() {
    sessionStorage.setItem('guestUserDetails', JSON.stringify(this.userDetail));
    if (this.curbSideDetails && this.curbSideDetails.carName && this.curbSideDetails.phNo) {
      sessionStorage.setItem('curbSideDetails', JSON.stringify(this.curbSideDetails));
    }
  }

  validateShippingAddressLine() {
    if (!this.shippingAddressValidation && this.userDetail && this.userDetail.shipping.addressLine1 && this.$auth.validatingPoBoxAddress(this.store.postboxAddress, this.userDetail.shipping.addressLine1)) {
      this.shippingAddressValidation = true;
      setTimeout(() => { 
        this.shippingAddressValidation = false;        
      }, 1000);
    }
  }

  onAddressValueChange(callApi = true) {
    this.isShippingAddressAdded = false;
    this.isAddressValidated = false;
    if (this.mode === this.nextDayDelivery) {
      this.copyToShippingAddress(false);
      // if (this.userDetail && this.userDetail.shipping.addressLine1 && this.$auth.validatingPoBoxAddress(this.store.postboxAddress, this.userDetail.shipping.addressLine1)) {
      //   return false;
      // }
      if (this.userDetail.shipping.addressLine1 && this.userDetail.shipping.country
        && this.userDetail.shipping.state && this.userDetail.shipping.zipCode) {
          this.isShippingAddressAdded = true;
          setTimeout(() => {
            if (callApi) {
              this.getGuestCartDetails(true).then()
              .catch(err => {
                this.$auth.printCustomerGenericLogs(err);
              });
            }
          }, 500);
      }
    }
    sessionStorage.setItem('guestUserDetails', JSON.stringify(this.userDetail));
  }

  copyToShippingAddress(apiCall) {
    if (this.userDetail.shipping.isCopyAsShipping) {
      this.userDetail.shipping.addressLine1 = this.userDetail.addressLine1;
      this.userDetail.shipping.addressLine2 = this.userDetail.addressLine2;
      this.userDetail.shipping.city = this.userDetail.city;
      if (this.userDetail.shipping.country !== this.userDetail.country) {
        this.userDetail.shipping.country = this.userDetail.country;
        this.countryChange(this.userDetail.shipping.country, true);
      }
      this.userDetail.shipping.state = this.userDetail.state;
      this.userDetail.shipping.zipCode = this.userDetail.zipCode;

      if (this.userDetail.shipping.addressLine1 && this.userDetail.shipping.country
        && this.userDetail.shipping.state && this.userDetail.shipping.zipCode) {
          this.isShippingAddressAdded = true;
      }

      this.userDetail.recipientFirstName = this.userDetail.firstName;
      this.userDetail.recipientLastName  = this.userDetail.lastName;
      if (apiCall) {
        this.getGuestCartDetails().then()
        .catch( err => {
          this.$auth.printCustomerGenericLogs(err);
        });
      }
    }
  }

  processDeliveryType() {

    if (this.$rootScope.tempdeliveryMode) {

      if (this.$rootScope.tempdeliveryMode === this.nextDayDelivery && this.cartContainsOnlyDsc()) {
        this.mode = this.inStoreDelivery;
        this.resetDeliveryMode(this.mode);
      } else {
        this.mode = this.$rootScope.tempdeliveryMode;
      }
      if (this.$rootScope.isCurbside) {
        this.isCurbside = this.$rootScope.isCurbside;
        this.curbSideDetails = this.$rootScope.curbSideDetails;
      }
    }
    else {
      this.mode = "";
    }

    // In store pickup only changes - when items contain deliverytype instore then hide shipping option
    if (this.cartDetail && this.cartDetail.cartItems && this.cartDetail.cartItems.length > 0) {
      const filteredInstoreItem = this.cartDetail.cartItems.filter(item => item.item.deliveryType === this.instorePickupOnly);
      if (filteredInstoreItem && filteredInstoreItem.length > 0) {
        this.filteredInstoreItem = true;
        this.mode = this.inStoreDelivery;
        this.resetDeliveryMode(this.mode);
      } else {
        this.filteredInstoreItem = false;
      }
      const filteredDropShipItem = this.cartDetail.cartItems.filter(item => item.item.deliveryType === this.dropShipOnly);
      if (filteredDropShipItem && filteredDropShipItem.length > 0) {
        this.filteredDropShipItem = true;
        this.mode = this.nextDayDelivery;
        this.resetDeliveryMode(this.mode);
      } else {
        this.filteredDropShipItem = false;
      }
    }
  }

  createShipToRequest() {
    if (this.mode === this.nextDayDelivery) {
      if (this.userDetail && this.userDetail.shipping && this.userDetail.shipping.zipCode && this.userDetail.shipping.addressLine1 && this.userDetail.shipping.city && this.userDetail.shipping.country&& this.userDetail.shipping.state) {
        return {
          name: this.userDetail.firstName + ' ' + this.userDetail.lastName,
          addressLine1: this.userDetail.shipping.addressLine1,
          addressLine2: this.userDetail.shipping.addressLine2,
          city: this.userDetail.shipping.city,
          state: this.createStateRequest(this.userDetail.shipping.state, this.userDetail.shipping.country),
          country: this.createCountryRequest(this.userDetail.shipping.country),
          zip: this.userDetail.shipping.zipCode,
          deliveryType: this.mode ? this.mode : this.inStoreDelivery
        };
      }
    }
    return null;
  }

  getTotalWeight() {
    return this.cartDetail.cartItems &&
      this.cartDetail.cartItems.map(item => item.item.weight * item.quantity)
        .reduce((prev, curr) => prev + curr, 0);
  }

  getShippingDiscountCharge() {
    if (this.cartContainsOnlyGift()) {
      return 0.00;
    }
    if (this.store.hasErply && this.erplyShop && this.erplyShop.shippingDiscount && this.mode !== this.inStoreDelivery) {
      return this.erplyShop.shippingDiscount;
    }
    if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.shippingDiscount && this.mode !== this.inStoreDelivery) {
      return this.cartDetail.shopCartResponse.shippingDiscount;
    }
    return 0;
  }
  getSelectedShipmentCharge() {
    if (this.cartContainsOnlyGift()) {
      return 0.00;
    }
    if (this.store.hasErply && this.erplyShop && this.erplyShop.shippingCharge && this.mode !== this.inStoreDelivery) {
      return this.erplyShop.shippingCharge;
    }
    if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.shippingCharge && this.mode !== this.inStoreDelivery) {
      return this.cartDetail.shopCartResponse.shippingCharge;
    }
    return 0;
  }

  subtotal() {
    return (this.store && this.store.hasErply) ? (this.erplyShop && this.erplyShop.originalPriceTotal ? this.erplyShop.originalPriceTotal : 0) : (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.subTotal ? this.cartDetail.shopCartResponse.subTotal : 0);
  }

  totalPrice(){
    return this.subtotal() +
    this.getTotalTax() -
    this.getTotalDiscount();
  }

  totalAmount() {
    if(this.store && this.store.hasErply){
      return this.erplyShop.amountToPay;
    } else {
      return this.subtotal() + 
      this.getSelectedShipmentCharge() +
      this.getTotalTax() -
      this.getTotalDiscount() -
      this.getShippingDiscountCharge();
    }
    
  }

  getTotalTax() {
    if (this.store && this.store.hasErply && this.erplyShop && this.erplyShop.totalTax && this.mode != '') {
      return this.erplyShop.totalTax;
    } 
    if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.totalTax && this.mode != '') {
      return this.cartDetail.shopCartResponse.totalTax;
    }
    return 0;
  }

  getTotalDiscount() {
    if (this.store && this.store.hasErply && this.erplyShop && this.erplyShop.erplyPromotionDiscount && this.mode != '') {
      return this.erplyShop.erplyPromotionDiscount;
    } 
    if (this.cartDetail && this.cartDetail.shopCartResponse && this.cartDetail.shopCartResponse.promoDiscount && this.mode != '') {
      return this.cartDetail.shopCartResponse.promoDiscount;
    }
    return 0;
  }

  shippingGrossPrice() {
    var totalGiftCardAmountPurchasing = 0.00;
    var $ctrl = this;
    angular.forEach(this.cartDetail.cartItems, function (item, key) {
      if (item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory &&
        item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith) {
        totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + (item.item.price * item.quantity);
      }
    });

    if (this.store.hasErply) {
      return (this.erplyShop && this.erplyShop.subTotal) ? (this.erplyShop.subTotal - totalGiftCardAmountPurchasing - this.getTotalDiscount()) : 0;
    } else {
      return (this.cartDetail && this.cartDetail.shopCartResponse) ? (this.cartDetail.shopCartResponse.subTotal - totalGiftCardAmountPurchasing - this.getTotalDiscount()) : 0;
    }

  }

  isShippingDiscountEligible() {
    let grossPrice = this.shippingGrossPrice();
    var res = false;
    var result = false;
    if (!this.isCartError) {
      res = ((this.storeDetail.isFreeShipping) && (grossPrice >= this.cartDetail.freeshipping.thresholdValue));
      var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
      var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
      var currentDate = new Date();
      if (res) {
        if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
          result = true;
        }
      }
    }
    return result;
  }

  cartContainsGiftCard() {
    return this.cartDetail && this.cartDetail.cartItems
      ? this.cartDetail.cartItems.filter(item => {
        var masterCode = item.item.masterProduct.masterCode;
        var seriesNumber = masterCode.charAt(0);
        var categoryId = item.item.masterProduct.category.id;
        return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
      }).length
      : false;
  }

  cartContainsDsc() {
    return this.cartDetail && this.cartDetail.cartItems
      ? this.cartDetail.cartItems.filter(item => {
        return item.item.masterProduct.masterCode === this.dscMasterCode;
      }).length
      : false;
  }

  cartContainsOnlyDsc() {
    // console.log(this.cartContainsGiftCard());
    const totalItemsInCart = this.cartDetail ? this.cartDetail.cartItems.length : 0;
    if (this.cartContainsDsc() && (totalItemsInCart === this.cartContainsDsc())) {
      this.mode = this.inStoreDelivery;
      this.resetDeliveryMode(this.mode);
      // console.log("If This mode is :", this.mode);
      return true;
    } else {
      if (this.$rootScope.tempdeliveryMode) {
        this.mode = this.$rootScope.tempdeliveryMode;
      } else {
        this.mode = "";
      }
      // console.log("Else This mode is :", this.mode);
      return false;
    }
  }

  cartContainsOnlyGift() {
    const totalItemsInCart = this.cartDetail && this.cartDetail.cartItems.length ? this.cartDetail.cartItems.length : 0;
    return this.cartContainsGiftCard() && (totalItemsInCart === this.cartContainsGiftCard());
  }

  // converts date to UTC date
  convertDatetoUTC(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(),
      date.getUTCMinutes(), date.getUTCSeconds());
  }

  // Function assumes that the timezone is sent in format "+-HH:MM"
  convertTimezoneToMilliseconds(timezone) {
    let arr = timezone.split(':');
    let signAndHours = arr[0];
    let minutes = +arr[1];
    let sign = signAndHours.charAt(0);
    let hours = +signAndHours.substr(1);
    let milliseconds = ((hours * 60) + minutes) * 60000;
    let result = (sign === '+') ? +milliseconds : -milliseconds;
    return result;
  }

  // creates date object in Store's timezone. Does not inc daytime saving, Use for current time only.
  // See momentJs library for daytime features etc. not implementing as we do not require it here.
  getStoreDate() {
    let systemDate = new Date();
    let UTCDate = this.convertDatetoUTC(systemDate);
    let timezoneInMilliseconds = this.storeDetail.timeZone && this.convertTimezoneToMilliseconds(this.storeDetail.timeZone);
    let storeDateInMilliseconds = UTCDate.getTime() + timezoneInMilliseconds;
    let storeDate = new Date(storeDateInMilliseconds);
    return storeDate;
  }

  // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
  changeStringtoDateObject(stringTime) {
    let timeArray = stringTime.split(':');
    let hours = timeArray[0];
    let minutes = timeArray[1];
    let timeObject = this.getStoreDate();
    timeObject.setMinutes(minutes);
    return timeObject.setHours(hours);
  }

  formattedTime(dateTime) {
    const date = dateTime ? new Date(dateTime) : this.getStoreDate();
    const hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
    let time = (hours < 10 ? `0${hours}` : hours) + ':' +
      (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes());
    const ampm = date.getHours() >= 12 ? ' PM' : ' AM';
    return time + ampm;
  }

  getStoreTiming(date) {
    const forDate = date || this.getStoreDate();
    const mapping = {
      '0': 'Sunday',
      '1': 'Monday',
      '2': 'Tuesday',
      '3': 'Wednesday',
      '4': 'Thursday',
      '5': 'Friday',
      '6': 'Saturday'
    };
    const day = mapping[forDate.getDay()];
    return this.storeDetail.storeTimings && this.storeDetail.storeTimings.filter(el => el.day === day)[0];
  }

  storeOpeningTime(forDate) {
    if (this.storeDetail.storeTimings) {
      let today = forDate || this.getStoreDate();
      const open = this.getStoreTiming(forDate).openTime;
      const hours = open.split(':')[0];
      const minutes = open.split(':')[1];
      today.setHours(hours);
      today.setMinutes(minutes);
      return today;
    }
  }

  storeClosingTime(forDate) {
    if (this.storeDetail.storeTimings) {
      let today = forDate || this.getStoreDate();
      const close = this.getStoreTiming(forDate).closeTime;
      const hours = close.split(':')[0];
      const minutes = close.split(':')[1];
      today.setHours(hours);
      today.setMinutes(minutes);
      return today;
    }
  }

  getNextWorkingDay() {
    const mapping = {
      'sunday': '0',
      'monday': '1',
      'tuesday': '2',
      'wednesday': '3',
      'thursday': '4',
      'friday': '5',
      'saturday': '6'
    };
    const forDate = this.getStoreDate();
    const workingDays = this.storeDetail.storeTimings.filter(el => !el.isHoliday);
    let nextWorkingDay;
    for (let i = 0; i < workingDays.length; i++) {
      if (forDate.getDay() < mapping[workingDays[i].day.toLowerCase()]) {
        nextWorkingDay = workingDays[i];
        break;
      }
    }
    nextWorkingDay = nextWorkingDay || workingDays[0];
    if (nextWorkingDay && mapping[nextWorkingDay.day.toLowerCase()] == forDate.getDay()) {
      nextWorkingDay.isSameDay = true;
    }
    return nextWorkingDay;
  }

  calculateInStorePick() {
    if (this.storeDetail.storeTimings) {
      let orderPlacing = this.getStoreDate();
      let pickupTime = this.storeClosingTime().setMinutes(
        this.storeClosingTime().getMinutes() - parseInt(this.storeDetail.inStorePickupTime)
      );
      if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.storeDetail.fullFillTime)) < pickupTime &&
        !this.getStoreTiming().isHoliday) {
        let origOrderPlacing = this.getStoreDate();
        // If Order is placed before opening of Store
        if (origOrderPlacing < this.storeOpeningTime()) {
          let opening = this.storeOpeningTime();
          const finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime)));
          this.estimatedDeliveryDateTime = opening;
          return finalTime;
        }
        this.estimatedDeliveryDateTime = orderPlacing;
        return 'Today, ' + this.formattedTime(orderPlacing);
      }
      else {
        return this.calculateNextDay();
      }
    }
  }

  calculateSameDay() {
    if (this.storeDetail.storeTimings) {
      let orderPlacing = this.getStoreDate();
      let lastDeliveryTime = this.changeStringtoDateObject(this.storeDetail.deliveryPickupTime);
      if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.storeDetail.fullFillTime)) < lastDeliveryTime &&
        // let deliveryBoy = this.storeClosingTime().setMinutes(this.storeClosingTime().getMinutes() - this.store.deliveryPickupTime);
        // if (orderPlacing.setMinutes(orderPlacing.getMinutes() + this.storeDetail.fullFillTime) < deliveryBoy &&
        !this.getStoreTiming().isHoliday) {
        let origOrderPlacing = this.getStoreDate();
        // If Order is placed before opening of Store
        if (origOrderPlacing < this.storeOpeningTime()) {
          let opening = this.storeOpeningTime();
          const finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime)));
          this.estimatedDeliveryDateTime = opening;
          return finalTime;
        }
        this.estimatedDeliveryDateTime = orderPlacing;
        return 'Today, ' + this.formattedTime(orderPlacing);
      }
      return null;
    }
  }

  calculateNextDay() {
    if (this.storeDetail.storeTimings) {
      let date;
      let nextDate;
      let opening;
      for (var z=1; z<=7; z++) {
          date = this.getStoreDate();
          nextDate = new Date(date.setDate(date.getDate() + z));
          if (!this.getStoreTiming(nextDate).isHoliday) {
            opening = this.storeOpeningTime(nextDate);
            // opening.setDate(opening.getDate() + 1);
            opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime));
            this.estimatedDeliveryDateTime = opening;
            
            if(z==7){
              return `next ${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
            }
            return `${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
          } 
        if(z==7){
          this.noTimeForOrderReadyBy = true;
          break;
        } 
      }
      // else {
      //   let d = this.getStoreDate();
      //   const nextWorkingDate = d.setDate(d.getDate() + (this.getNextWorkingDay().id + 6 - d.getDay()) % 7);
      //   let opening = this.storeOpeningTime(new Date(nextWorkingDate));
      //   opening.setMinutes(opening.getMinutes() + parseInt(this.storeDetail.fullFillTime));
      //   this.estimatedDeliveryDateTime = opening;
      //   if (this.getNextWorkingDay().isSameDay) {
      //     return `next ${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
      //   } else {
      //     return `${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
      //   }
      // }
    }
  }

  dateToString(dateobj) {
    let yr = dateobj.getFullYear();
    let month = dateobj.getMonth() + 1;
    let date = dateobj.getDate();
    let hr = dateobj.getHours();
    let min = dateobj.getMinutes();
    let sec = dateobj.getSeconds();
    return '' + yr + '-' + month + '-' + date + ' ' + hr + ':' + min + ':' + sec;
  }

  createCountryRequest(countrykey) {
    const country = this.billingCountries.find(ele => ele.label === countrykey);
    if (country) {
      return {
        "id": country.value,
        "countryCode": country.label,
        "name": country.name
      };
    }
    return null;
  }

  
  createStateRequest(statekey, countrykey) {
    // console.log("statekey", statekey);
    // console.log("countrykey", countrykey);
    // console.log("this.billingCountries", this.billingCountries);
    countrykey = countrykey.countryCode?countrykey.countryCode:countrykey;
    const stateList = this.billingCountries.find(ele => ele.label === countrykey).states;
    const state = stateList.find(ele => ele.value === statekey);
    if (state) {
      return {
        id: state.id,
        code: state.value,
        name: state.label,
        country: this.createCountryRequest(countrykey)
      };
    }
    return null;
  }

  createGuestUserRequest() {
    const cartData = this.guestCartList.filter(data => !data.isDscCard);
    let expectedDeliveryTime = null;
    if (this.mode === this.inStoreDelivery) {
      expectedDeliveryTime = this.calculateInStorePick();
    }
    else if (this.mode === 'Same Day Delivery') {
      expectedDeliveryTime = this.calculateSameDay();
    }
    else {
      expectedDeliveryTime = this.calculateNextDay();
    }
    let dateStr = this.estimatedDeliveryDateTime ? this.dateToString(this.estimatedDeliveryDateTime) : null;

    // Setting User Data in session
    this.$rootScope.guestUserDetails = this.userDetail;
    sessionStorage.setItem('guestUserDetails', JSON.stringify(this.userDetail));
    if (this.curbSideDetails && this.curbSideDetails.carName && this.curbSideDetails.phNo) {
      this.$rootScope.curbSideDetails = this.curbSideDetails;
      sessionStorage.setItem('curbSideDetails', JSON.stringify(this.curbSideDetails));
    }
    return {
      guestUser: {
        email: this.userDetail.email,
        phoneNumber: this.userDetail && this.userDetail.phoneNumber ? this.userDetail.phoneNumber : null,
        isActive: false,
        isEmployee: false,
        customer: {
          firstName: this.userDetail.firstName,
          lastName: this.userDetail.lastName,
          email: this.userDetail.email,
          phoneNumber: this.userDetail && this.userDetail.phoneNumber ? this.userDetail.phoneNumber : null
        },
        admin: null,
        billingAddressLine1: this.userDetail.addressLine1,
        billingAddressLine2: this.userDetail.addressLine2,
        billingCity: this.userDetail.city,
        billingState: this.createStateRequest(this.userDetail.state, this.userDetail.country),
        billingCountry: this.createCountryRequest(this.userDetail.country),
        billingZipCode: this.userDetail.zipCode,
        shippingAddressLine1: this.mode === this.nextDayDelivery ? this.userDetail.shipping.addressLine1 : this.userDetail.addressLine1,
        shippingAddressLine2: this.mode === this.nextDayDelivery ? this.userDetail.shipping.addressLine2 : this.userDetail.addressLine2,
        shippingCity: this.mode === this.nextDayDelivery ? this.userDetail.shipping.city : this.userDetail.city,
        shippingState: this.createStateRequest(this.mode === this.nextDayDelivery ? this.userDetail.shipping.state : this.userDetail.state, this.mode === this.nextDayDelivery ? this.userDetail.shipping.country : this.userDetail.country),
        shippingCountry: this.createCountryRequest(this.mode === this.nextDayDelivery ? this.userDetail.shipping.country : this.userDetail.country),
        shippingZipCode: this.mode === this.nextDayDelivery ? this.userDetail.shipping.zipCode : this.userDetail.zipCode,
        isExistingRegistration: false
      },
      guestCartItems: cartData,
      deliveryType: this.mode,
      isCurbside: this.isCurbside,
      curbSideDetails: JSON.stringify(this.curbSideDetails),
      discountCode: this.discountCouponCode,
      shippingCharge: +this.getSelectedShipmentCharge() ? (this.getSelectedShipmentCharge()).toFixed(2) || 0 : 0,
      shippingDiscount: +this.getShippingDiscountCharge() ? this.getShippingDiscountCharge().toFixed(2) : 0,
      totalPrice: +parseFloat(this.totalPrice()).toFixed(2),
      orderNotes: this.orderNotes,
      manualPromotionIDs: this.discountCouponCode,
      expectedDeliveryTime: dateStr,
      estimatedDeliveryDateTime: this.estimatedDeliveryDateTime,
      isGiftOrder: this.isGiftOrder,
      recipientFirstName: this.userDetail && this.userDetail.recipientFirstName ? this.userDetail.recipientFirstName : null,
      recipientLastName: this.userDetail && this.userDetail.recipientLastName ? this.userDetail.recipientLastName : null
    };
  }

  async submitAll(userForm, curbsideForm) {

    if (this.filteredInstoreItem && this.filteredDropShipItem) {
      this.toaster.pop('success', 'Please modify your cart!');
      return false;
    }

    if (userForm.$invalid) {
      userForm.$submitted = true;
      this.toaster.pop('success', 'Please Enter User Information');
      return false;
    }

    if (this.mode === this.inStoreDelivery && this.isCurbside && curbsideForm.$invalid) {
      curbsideForm.$submitted = true;
      this.toaster.pop('success', 'Please Enter Curb Side Information');
      return false;
    }

    // Validating PO Box character in address
    if ((this.mode === this.nextDayDelivery) && this.$auth.validatingPoBoxAddress(this.store.postboxAddress, this.userDetail.shipping.addressLine1)) {
      return false;
    }

    // Validating user Email
    const isEmailRegistered = await this.verifyEmail(this.userDetail.email);

    if (isEmailRegistered) {
      return;
    }

    // Avalara resolving address
    if(!this.isAddressValidated && this.mode === this.nextDayDelivery){
      let userForAddressCheck = this.getUserDetailForAvalaraAddressCheck(this.userDetail);
      this.$auth.avalaraResolveAddress(userForAddressCheck, this.store)
      .then( resolveAddress => {
          console.log("ResolveAddress : ", resolveAddress);
          this.$auth.openPopUpForAddressResolve(userForAddressCheck,resolveAddress, 
            addResolved => {
              this.$spinner.hide('appSpinner');
              console.log("Call back function", addResolved);
              if(addResolved.isCanceled){
                console.log("Canceled");
              } else {
                this.isAddressValidated=true;
                this.userDetail.shipping.addressLine1 = addResolved.shippingAddressLine1;
                this.userDetail.shipping.addressLine2 = addResolved.shippingAddressLine2;
                this.userDetail.shipping.city = addResolved.shippingCity;
                this.userDetail.shipping.state = addResolved.shippingState.code;
                this.userDetail.shipping.country = addResolved.shippingCountry.countryCode;
                this.userDetail.shipping.zipCode = addResolved.shippingZipCode;
                this.guestProceedingToPayment();
              }
            });
      })
      .catch( err => {
        this.isAddressValidated=true;
        this.$spinner.hide('appSpinner');
        this.guestProceedingToPayment();
        console.log("Error in edit : ", err);
        this.$auth.printCustomerGenericLogs(err);
      });
    } else {
      this.guestProceedingToPayment();
    }
  }

  goToHomePage() {
    let storeName = '';
    if (this.store.storeName && this.store.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.store.storeName;
    } else {
      if (this.store && this.store.storeName) {
        storeName = this.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  goToMerchantPage(data, method) {
    method = method || 'post';

    let form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', data.message);

    let payIdField = document.createElement('input');
    payIdField.setAttribute('type', 'hidden');
    payIdField.setAttribute('name', 'PaymentID');
    payIdField.setAttribute('value', data.additionalInfo);
    form.appendChild(payIdField);

    let returnMethodField = document.createElement('input');
    returnMethodField.setAttribute('type', 'hidden');
    returnMethodField.setAttribute('name', 'ReturnMethod');
    returnMethodField.setAttribute('value', 'POST');
    form.appendChild(returnMethodField);

    document.body.appendChild(form);
    form.submit();
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  getDeviceParameter() {
    if (window.innerWidth <= 576) {
      return 'm';
    }
    else if (window.innerWidth > 576 && window.innerWidth <= 768) {
      return 't';
    }
    else if (window.innerWidth > 768) {
      return 'd';
    }
  }

  resetDeliveryMode(mode) {
    this.$rootScope.tempdeliveryMode = mode;
    this.onAddressValueChange(false);
  }

  generateDiscountValidityMsg(status) {
    this.discountCouponStatus = null;
    this.cError = false;
    if (status) return;
    else if (this.isDiscountCouponValid === false) {
      this.cError = true;
      this.discountCouponStatus = 'Invalid Code';
    }
    if (this.isDiscountCouponEnabled === false) {
      this.cError = true;
      return this.discountCouponStatus = 'Invalid Code';
    }
    if (this.isDiscountCouponExpired === true) {
      this.cError = true;
      return this.discountCouponStatus = 'This Code  was expired.';
    }
    if (!this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
      this.cError = true;
      return this.discountCouponStatus = "Promo Code cannot be used to purchase a DSC membership or GiftCard.  Please add more product to use a Promo code.";
    }
    if (this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
      this.discountCouponStatus = 'Successfully Applied';
    }
    else if (this.isDiscountCouponValid === false) {
      this.cError = true;
      this.discountCouponStatus = 'Invalid Code';
    }
    else if (this.isDiscountTotalNegative && this.isDiscountCouponValid) {
      this.cError = true;
      this.discountCouponStatus = 'Your Subtotal Amount should be more than the Discount Code amount';
    }
    else {

      this.discountCouponStatus = null;
    }
    return this.discountCouponStatus;
  }

  isFreeShippingOfferAvailable() {
    if (this.storeDetail && this.cartDetail.freeshipping) {
      var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
      var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
      var currentDate = new Date();
      var result = false;
      if (this.storeDetail) {
        if (this.storeDetail.isFreeShipping) {
          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
            result = true;
          }
        }
      }

    }
    return result;
  }

  getFreeShippingRemainingAmount() {
    if (this.cartDetail) {
      if (this.cartDetail.freeshipping) {
        this.shippingOffer.thresholdAmount = this.cartDetail.freeshipping.thresholdValue;
      }
    }
    let remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
    if (remainingAmount >= 0) {
      this.shippingOffer.isOfferEligible = true;
    }
    else {
      this.shippingOffer.isOfferEligible = false;
    }
    return remainingAmount * -1;
  }

  showFreeShippingOfferDetail() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free Shipping within Zone 2';
    }
    else {
      tittle = 'Free Shipping within Zone 2';
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + tittle + '</h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  showFreeShippingOfferDetailCan() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free shipping in Zones 0-1';
    }
    else {
      tittle = 'Free shipping in Zones 0-1';
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + tittle + '</h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  totalRetailPrice() {
    return this.cartDetail.cartItems.map(item => item.item.price * item.quantity)
      .reduce((prev, curr) => prev + curr);
  }

  applyDiscounts(isDiscountApplied) {
    var $ctrl = this;
    this.isEmailNull = false;
    this.iszipCodeNull = false;
    this.isPhoneNumberNull = false;
    if(this.mode===''){
      this.promptForDeliveryType('',"Please select an option for how to receive your order");
      // this.toaster.pop('success', 'Please choose how to receive your order!');
      return false;
    } 
    // else if(this.userDetail.email === '' || this.userDetail.email === null || this.userDetail.email === undefined){
    //   // this.promptForDeliveryType('',"Enter email address");
    //   this.isEmailNull = true;
    //     return false;
    // } else if(this.userDetail.zipCode === '' || this.userDetail.zipCode === null || this.userDetail.zipCode === undefined){
    //   this.iszipCodeNull = true;
    //     return false;
    // } 
    // else if(this.userDetail.phoneNumber === '' || this.userDetail.phoneNumber === null || this.userDetail.phoneNumber === undefined){
    //   this.isPhoneNumberNull = true;
    //     return false;
    // }
     else {
      // Removing Free item when promo code removed
      // if (this.cartDetail && this.cartDetail.cartItems && this.cartDetail.cartItems.length && this.guestCartList) {
      //   this.guestCartList.forEach(ele => {
      //     const findItem = this.cartDetail.cartItems.find(item => ele.itemId === item.item.id);
      //     // Removing Free item when discount is removed
      //     if (ele && findItem && findItem.discountTypeApplied === 'FREEITEM' && findItem.isDiscountApplied && this.discountCouponCode !== 'FREEITEM') {
      //       if (ele.quantity === 1) {
      //         this.$auth.removetoGuestCart(ele.itemId);
      //       } else {
      //         this.updateItemInCart(ele.quantity - 1, ele);
      //       }
      //     }
      //   });
      // }
    
      if (isDiscountApplied) {
        sessionStorage.setItem('discountCoupon', this.discountCouponCode);
        if (this.discountCouponCode && this.storeDetail.hasErply) {
          // $ctrl.erplyCampaignStatus = 'Promotion Applied automatically';
          // $ctrl.isErplyCampaignValid = true;
        } else {
          // $ctrl.isErplyCampaignValid = false;
          // if (this.curbSideDetails) {
          //   this.$rootScope.curbSideDetails = this.curbSideDetails;
          // }
          // this.getGuestCartDetails().then();
          // this.$auth.getGuestCart();
        }
        if (this.curbSideDetails) {
          this.$rootScope.curbSideDetails = this.curbSideDetails;
        }
        this.getGuestCartDetails().then()
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        });
        this.$auth.getGuestCart();
        return;
      }
    }
  }

  orderNotesSession() {
    sessionStorage.setItem('orderNotesSession', this.orderNotes);
  }

  navigateCart() {
    this.$state.go('guestcart');
  }

  deliveryModechanges(mode, isCurbside = false) {
    if (mode !== this.nextDayDelivery) {
      this.isCurbside = isCurbside;
      this.$rootScope.isCurbside = isCurbside;
    } else {
      this.isCurbside = false;
      this.$rootScope.isCurbside = false;
      this.userDetail.shipping.country = this.userDetail.shipping.country ? this.userDetail.shipping.country : this.store.country.countryCode;
      this.countryChange(this.userDetail.shipping.country, true);
    }
    this.mode = mode;
    this.resetDeliveryMode(mode);
    this.getGuestCartDetails().then()
    .catch(err => {
      this.$auth.printCustomerGenericLogs(err);
    });
  }

  getCurbsideDetails(fromSubmit = false) {
    var $ctrl = this;
    this.$uibModal.open({
      size: 'md',
      template: `<div class="modal-header modalheaderbg btn-primary"><h5>Curbside pickup details</h5></div>
        <div class="modal-body" id="modal-body">
          <div class="container-fluid"> 
            <div class="row"> 
              <form name="curbsideForm" ng-submit="submit(curbsideForm)" autocomplete="off" novalidate>
                <div class="col-md-12 error-text" ng-if="curbsideForm.error.message">{{curbsideForm.error.message}}</div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Car make/model/color * </label>
                      <input name="carName" type="text" required ng-model="carName" class="form-control"/>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                      <label>Phone Number * </label>
                      <input name="phNo" type="tel" required ui-mask="(999) 999-9999" ng-model="phNo" class="form-control"/>
                    </div>
                </div>
                <div class="col-md-12" style="margin-top: -3%;">
                    <div class="form-group">
                      <label>You will receive an email when your order is placed and a second email when your order is ready.</label><br/>
                      <strong>Store Instructions</strong><br/>
                      <label ng-bind="storeInstruction"></label>
                    </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-footer m-t-1">
            <button class="btn" type="button" ng-click="cancel()">Cancel</button>
            <button class="btn btn-primary m-l-1" type="button" ng-click="ok(curbsideForm)">Submit</button>
        </div>`,
      controller: ['$scope', '$uibModalInstance',
        function ($scope, $uibModalInstance) {
          $scope.phNo = $ctrl.profile.phoneNumber;
          $scope.storeInstruction = $ctrl.store.curbSideInstruction;
          if ($ctrl.curbSideDetails) {
            $scope.carName = $ctrl.curbSideDetails.carName ? $ctrl.curbSideDetails.carName : "";
            $scope.phNo = $ctrl.curbSideDetails.phNo ? $ctrl.curbSideDetails.phNo : $scope.phNo;
          }
          // eslint-disable-next-line arrow-parens
          $scope.ok = (curbsideForm) => {
            if ($scope.carName && $scope.phNo) {
              $ctrl.curbSideDetails = {
                carName: $scope.carName ? $scope.carName : "",
                phNo: $scope.phNo ? $scope.phNo : ""
              };
              $ctrl.$rootScope.curbSideDetails = $ctrl.curbSideDetails;
              $uibModalInstance.close();
              if (fromSubmit) {
                $ctrl.submit();
              }
            } else {
              curbsideForm.error = { message: 'Please fill All details!' };
            }
          };
          $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel');
          };
        }
      ],
      backdrop: 'static',
      keyboard: false
    });
  }

  isMobileOnly() {
    return this.$auth.isMobileDevice();
  }

  countryChange(country, isShipping, fromHtml = false) {
    var ctrl = this;
    if (fromHtml) {
      if (isShipping) {
        this.userDetail.shipping.state = null;
      } else {
        this.userDetail.state = null;
      }
    }
    angular.forEach(this.billingCountries, function (value) {
      if (country === value.label) {
        if (isShipping) {
          ctrl.shippingStates = value.states;
        } else {
          ctrl.billingStates = value.states;
        }
      }
    });
  }

  async verifyEmail(email, showSpinner = true) {
    let isRegistered = false;
    if (email) {
      if (showSpinner) {
        this.$spinner.show('appSpinner');
      }
      var ctrl = this;
      await this.$auth.verifyCustomerEmail({
        email: email,
        store: {
          storeURLName: this.store.storeURLName
        }
      }).then(success => {
        ctrl.$spinner.hide('appSpinner');
        isRegistered = false;
      }, error => {
        isRegistered = false;
        if (error && error.data && error.data.errorCode == 615) {
          if (!ctrl.loginPopuOpened) {
            ctrl.toaster.pop('success', error.data.message);
            ctrl.loginPopup(email);
          }
          if (!showSpinner) {
            setTimeout(() => {
              ctrl.loginPopuOpened = false;
            }, 1000);
          } else {
            ctrl.loginPopuOpened = false;
          }
          isRegistered = true;
        }
        ctrl.$spinner.hide('appSpinner');
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
    }
    return isRegistered;
  }

  
  loginPopup(email) {
    var $ctrl = this;
    this.$uibModal.open({
      size: 'sm',
      template: `<div class="modal-body" id="modal-body">
            <div class="row">
              <div class="col-md-12">
                <form class="login-form" name="loginForm"
                  ng-submit="submit(loginForm)"
                  autocomplete="off"
                  novalidate>
                        <div style="color: #a4182d;">Good news! You already have an account. Please login to proceed.<br/></div>
                        <div class="error-text" ng-bind="loginForm.error.message"></div>
                        <div class="form-group"
                            ng-class="{'has-danger': (loginForm.$submitted || loginForm.email.$touched) && loginForm.email.$invalid }">
                          <label>Email&nbsp<span><a href="#" tooltips tooltip-template="Daily Savings Club Members must register with the same email address that is associated with the 'in-store' account in order to receive membership benefits. If you do not know which email address was provided, please contact the store." tooltip-size="small" tooltip-smart="true" tooltip-class="info-tooltip" tooltip-side="right">
                          <img src="` + $ctrl.info + `" alt="info"></a></span></label>
                          <input name="email"
                                type="email"
                                ng-pattern="/^([A-Za-z0-9._-]+@[A-Za-z-0-9_-]+\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*\.[A-Za-z]{2,}|[A-Za-z0-9._-]+@[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*\.[A-Za-z]{2,}\.[A-Za-z]{2,})$/"
                                class="form-control"
                                ng-model="email"
                                ng-disabled="true"
                                required>
                          <div ng-messages="loginForm.email.$error"
                              class="form-control-feedback"
                              ng-show="loginForm.email.$touched || loginForm.$submitted">
                            <div ng-message="required">Enter email address</div>
                            <div ng-message="pattern">Enter a valid email address</div>
                            <div ng-message="email">Enter a valid email address</div>
                            <div class="error-text"
                                ng-show="loginForm.errors.email && !loginForm.email.$error.required && !loginForm.email.$error.pattern">{{ loginForm.errors.email[0] }}</div>
                          </div>
                        </div>
                        <div class="form-group"
                            ng-class="{'has-danger': (loginForm.$submitted || loginForm.password.$touched) && loginForm.password.$invalid }">
                          <label>Password</label>
                          <input name="password"
                                type="password"
                                class="form-control"
                                ng-model="login.password"
                                ng-minlength="6"
                                ng-maxlength="60"
                                required>
                          <div ng-messages="loginForm.password.$error"
                              class="form-control-feedback"
                              ng-if="loginForm.password.$touched || loginForm.$submitted">
                            <div ng-message="required">Password is required</div>
                            <div ng-message="minlength">Minimum Password length should be 6</div>
                            <div ng-message="maxlength">Maximum Password length should be 60</div>
                            <div class="error-text"
                                ng-show="loginForm.errors.password && !loginForm.password.$error.required">{{ loginForm.errors.password[0] }}</div>
                          </div>
                        </div>
                      
                        <p class="text-xs-center gray-text mb-4">
                          By using this site, you agree to <a target="_blank" ng-click="ok()" ui-sref="tnc" class="link-text">Terms and Conditions</a> and <a target="_blank" ui-sref="rules" class="link-text">Rules</a>.
                        </p>
                      
                        <button type="submit"
                                class="btn btn-primary btn-block login-margin btn-sm-text mockup-btn">Log in</button>
                      
                        <p class="mt-4 m-b-1">
                          <a ui-sref="forgotPassword" ng-click="ok()" class="link-text gray-text">Forgot Password?</a>
                        </p>
                      
                      </form>
              </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" type="button" ng-click="ok()">Cancel</button>
        </div>`,
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {
          $scope.email = email;
          $ctrl.loginPopuOpened = true;
          $scope.ok = () => {
            $uibModalInstance.close();
          };

          $scope.isScreenSmall = () => {
            if ($ctrl.$window.innerHeight < 300) return true;
          };

          $scope.submit = function (form) {
            if (form.$invalid) {
              return;
            }
            form.error = {};
            $ctrl.$spinner.show('appSpinner');
            $ctrl.$auth.registerLogin({
              email: form.email.$viewValue,
              password: form.password.$viewValue
            })
              .then(
                success => {
                  $ctrl.$spinner.hide('appSpinner');
                  $uibModalInstance.close();
                  $ctrl.$rootScope.$emit('loginFromPopup', success);
                },
                error => {
                  $ctrl.$spinner.hide('appSpinner');
                  if (error.data.errorCode === 621) {
                    $uibModalInstance.close();
                    $ctrl.$state.go('inactive');
                  }
                  else {
                    form.error = error.data;
                  }
                })
                .catch(err => {
                  $ctrl.$auth.printCustomerGenericLogs(err);
                });
          };
        }
      ]
    }).result.then(() => {
      $ctrl.loginPopuOpened = true;
    }, () => {
      $ctrl.loginPopuOpened = false;
    });
  }

  promptForDeliveryType(title,detail){
      
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + title + '</h5>' +
        // '<span ng-bind-html="'+detailed+'" > </span>'+
        detail +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', '$uibModalInstance',
        function ($scope, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  updateItemInCart(quantity, item) {
    const guestCartItems = this.guestCartList.map(element => {
      if (element.itemId === item.itemId) {
        element.quantity = quantity;
      }
      return element;
    });
    if (guestCartItems) {
      this.$auth.updatetoGuestCart(guestCartItems);
    }
  }

  guestProceedingToPayment() {
    const reqData = this.createGuestUserRequest();

    this.isCallingAPI = true;
    this.$spinner.show('appSpinner');
    this.$order.orderGuestCheckout(reqData)
      .then(
        success => {
          this.isCallingAPI = false;
          this.$spinner.hide('appSpinner');
          if (success.data.userToken) {
            this.$state.go('card-detail', { orderId: success.data.orderId });
          } else {
            this.toaster.pop('success', 'Please Try again!');
          }
        },
        error => {
          this.isCallingAPI = false;
          this.$spinner.hide('appSpinner');
          if (error.data.errorCode === 640) {
            this.toaster.pop('success', 'Please select Delivery Option.');
            return;
          }
          if (error.data.errorCode === 645) {
            this.toaster.pop('success', error.data.message);
            return;
          }
          if (error.data.errorCode === 665 || error.data.errorCode === 671) {
            this.$state.go('guestcart');
            return;
          }
          if (error.data.errorCode === 659) {
            this.billingError = error.data.message;
            var $ctrl = this;
            this.$uibModal.open({
              size: 'sm',
              template: '<div class="modal-body" id="modal-body">' +
                '<h5 class="font-weight-bold">{{billingError}}</h5>' +
                '</div>' +
                '<div class="modal-footer">' +
                '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
                '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' +
                '</div>',
              controller: ['$scope', 'orderService', '$uibModalInstance', '$state',
                function ($scope, $order, $uibModalInstance, $state) {
                  $scope.billingError = $ctrl.billingError;
                  $scope.ok = () => {
                    $uibModalInstance.close();
                    $state.go('profile.edit');
                  };
                  $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                }
              ]
            });
            return;
          } else {
            this.$uibModal.open({
              size: 'sm',
              template: '<div class="modal-body" id="modal-body">' +
                `<h5 class="font-weight-bold">We can't process your order at this time. Please call the store.</h5>` +
                '</div>' +
                '<div class="modal-footer">' +
                '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">OK</button>' +
                '</div>',
              controller: ['$scope', 'orderService', '$uibModalInstance',
                function ($scope, $order, $uibModalInstance) {
                  $scope.ok = () => {
                    $uibModalInstance.close();
                    location.reload();
                  };
                  $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                }
              ]
            });
          }
          // this.$uibModal.open({
          //   size: 'sm',
          //   template: '<div class="modal-body" id="modal-body">' +
          //     '<h5 class="font-weight-bold">Price has been updated for this order. Confirm to reload your Cart details.</h5>' +
          //     '</div>' +
          //     '<div class="modal-footer">' +
          //     '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
          //     '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' +
          //     '</div>',
          //   controller: ['$scope', 'orderService', '$uibModalInstance',
          //     function ($scope, $order, $uibModalInstance) {
          //       $scope.ok = () => {
          //         $uibModalInstance.close();
          //         location.reload();
          //       };
          //       $scope.cancel = () => $uibModalInstance.dismiss('cancel');
          //     }
          //   ]
          // });
        }
      ).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }


  getUserDetailForAvalaraAddressCheck(profile){
    return {
      'phoneNumber': profile.phNo,
      'customer': profile.customer,
      'billingAddressLine1': this.userDetail.addressLine1,
      'billingAddressLine2': this.userDetail.addressLine2,
      'billingCity': this.userDetail.city,
      'billingState': this.createStateRequest(this.userDetail.state, this.userDetail.country),
      'billingCountry': this.createCountryRequest(this.userDetail.country),
      'billingZipCode': this.userDetail.zipCode,
      'shippingAddressLine1': this.userDetail.shipping.addressLine1,
      'shippingAddressLine2': this.userDetail.shipping.addressLine2,
      'shippingCity': this.userDetail.shipping.city,
      'shippingState': this.createStateRequest(this.mode === this.nextDayDelivery ? this.userDetail.shipping.state : this.userDetail.state, this.mode === this.nextDayDelivery ? this.userDetail.shipping.country : this.userDetail.country),
      'shippingCountry': this.createCountryRequest(this.userDetail.shipping.country),
      'shippingZipCode': this.userDetail.shipping.zipCode,
      'store': this.store
    };
  }

  
  infoPopup() {
    document.getElementById('popup').style.display = 'block';
    setTimeout(() => {
     if (document.getElementById('popup').style.display === 'block' && this.showPopup === false) {
      this.hideinfoPopup();
     }
     }, 5000);
  }
  hideinfoPopup() {
    document.getElementById('popup').style.display = 'none';
    this.showPopup = false;
  }
  infoPopuponhover() {
    document.getElementById('popup').style.display = 'block';
    this.showPopup = true;
  }
  infoPopupFee() {
    document.getElementById('popup1').style.display = 'block';
    setTimeout(() => {
     if (document.getElementById('popup1').style.display === 'block' && this.showPopupFee === false) {
      this.hideinfoPopupFee();
     }
     }, 5000);
  }
  hideinfoPopupFee() {
    document.getElementById('popup1').style.display = 'none';
    this.showPopupFee = false;
  }
  infoPopuponhoverFee() {
    document.getElementById('popup1').style.display = 'block';
    this.showPopupFee = true;
  }

  setErplyCartResponseValue(showcart) {
    console.log("Showcart : ", showcart);
    this.erplyDis = [];
    var dis ={};
    var ctrl = this;
    var i = 0;
    angular.forEach(showcart.erplyPromoAndDiscount, function (item,key) {
      console.log('key', key);
      console.log('item', item);
      dis ={};
      dis.key = key;
      dis.value = item;
      dis.sortId = i+1;
      i=i+1;
      ctrl.erplyDis.push(dis);
    });
    console.log("Guest Delivery - ctrl.erplyDis", ctrl.erplyDis);
  }
  
  getAdjustedLabelName(promoLabel) {
    if(promoLabel!=null && promoLabel.length>this.promoLengthToBeShown){
      return promoLabel.substring(0, this.promoLengthToBeShown-3)+"...";
    } else {
      return promoLabel;
    }
  }

  hideinfoPromoNamePopup(prefix,index, itemName, promoName) {
    var divId = "";
    if(itemName!=null){
      divId = prefix+''+index+''+itemName+''+promoName;
    } else {
      divId =prefix+''+index+''+ promoName;
    }
    document.getElementById(divId).style.display = 'none';
    this.showPopup = false;
  }

  infoPopupPromoNameonhover(prefix,index, itemName, promoName) {
    var divId = "";
    if(itemName!=null){
      divId = prefix+''+index+''+itemName+''+promoName;
    } else {
      divId =prefix+''+index+''+ promoName;
    }
    document.getElementById(divId).style.display = 'block';
    this.showPopup = true;
  }

}




// WEBPACK FOOTER //
// ./src/app/order/delivery/guestDelivery.js